/**
 * API utility for generating random names
 */

import { MULTIPLAYER } from "./constants";

function getHttpApiUrl(): string {
    const hostname = window.location.hostname;

    // Check if running locally
    if (hostname === "localhost") {
        return "https://api.sbgtv.tech/generate/randomName";
    }

    // For deployed environments
    return `https://api.sbgtv.tech/generate/randomName`;
}

/**
 * Fetches a random name from the API
 * @param seed - Optional seed value for deterministic name generation
 * @returns Promise<string> - The generated random name
 * @throws Error if the API call fails
 */
export async function getRandomName(seed?: string): Promise<string> {
    try {
        const apiUrl = getHttpApiUrl();

        // Add seed parameter if provided
        const url = new URL(apiUrl);
        if (seed) {
            url.searchParams.append("seed", seed);
        }

        const response = await fetch(url.toString());
        const data = await response.json();

        if (!response.ok) {
            console.error(`API request failed with status: ${response.status} ${data}`);
            return MULTIPLAYER.DEFAULT_USERNAME;
        }

        if (!data.username) {
            console.error(`Missing username field: ${data}`);
            return MULTIPLAYER.DEFAULT_USERNAME;
        }

        return data.username;
    } catch (error) {
        console.error("Error fetching random name:", error);
        return MULTIPLAYER.DEFAULT_USERNAME;
    }
}
